import { Icon, NoteIconsDictionary } from '@slite/icons'

export const DEFAULT_CATEGORIES_ORDER = [
  'objects',
  'activity',
  'places',
  'people',
  'nature',
  'symbols',
  'foods',
  'flags',
]

export const DEFAULT_SUGGESTED_EMOJIS = [
  'white_check_mark',
  'calendar',
  'hammer',
  'hammer_and_wrench',
  'rocket',
  'writing_hand',
  'dart',
  'bulb',
  'computer',
  'speech_balloon',
  'memo',
  'mega',
  'gear',
  'file_folder',
  'art',
  'sparkles',
  'zap',
  'handshake',
  'world_map',
  'wave',
  'studio_microphone',
  'fire',
  'chart_with_upwards_trend',
  'spiral_note_pad',
  'moneybag',
  'briefcase',
  'books',
  'question',
  'bar_chart',
  'dollar',
  'x',
  'eyes',
  'scroll',
  'no_entry_sign',
  'crystal_ball',
  'iphone',
  'book',
  'department_store',
  'crossed_swords',
  'building_construction',
  'warning',
  'muscle',
  'microphone',
  'boom',
  'earth_americas',
  'pencil2',
  'sun_with_face',
  'exclamation',
  'money_with_wings',
  'test_tube',
  'couch_and_lamp',
  'balloon',
  'tennis',
  'anchor',
  'dark_sunglasses',
]

export type EmojiPickerIconColor = {
  id: string
  light: string
  dark: string
}

export enum IconColorKeys {
  DARK = 'dark',
  GREY = 'grey',
  YELLOW = 'yellow',
  ORANGE = 'orange',
  PINK = 'pink',
  PURPLE = 'purple',
  BLUE = 'blue',
  TURQUOISE = 'turquoise',
  GREEN = 'green',
}

export const ICONS_COLORS: EmojiPickerIconColor[] = [
  { id: IconColorKeys.DARK, light: '#6a707c', dark: '#acb1b9' }, //shade-20
  { id: IconColorKeys.GREY, light: '#9da3af', dark: '#757d8a' }, //shade-30
  { id: IconColorKeys.YELLOW, light: '#CB912F', dark: '#C28C1E' },
  { id: IconColorKeys.ORANGE, light: '#D96826', dark: '#D35E1D' },
  { id: IconColorKeys.PINK, light: '#DC658B', dark: '#CA8199' },
  { id: IconColorKeys.PURPLE, light: '#A478C4', dark: '#927AC2' },
  { id: IconColorKeys.BLUE, light: '#578EE0', dark: '#638DCA' },
  { id: IconColorKeys.TURQUOISE, light: '#549693', dark: '#63A7A3' },
  { id: IconColorKeys.GREEN, light: '#689B27', dark: '#809F60' },
]

export const ICONS_COMPONENTS: Record<string, Icon> = NoteIconsDictionary
